<app-toolbar (toggleMenu)="toggleMenu()" (toggleMessages)="toggleDrawerStatus()"></app-toolbar>
<mat-sidenav-container>
	<mat-sidenav style="display: flex; flex-direction: column" [mode]="mode" [opened]="sideNavOpened">
		<app-side-menu></app-side-menu>
	</mat-sidenav>
	<mat-sidenav-content>
		<app-tenant-action-banner *ngIf="!xsmall"></app-tenant-action-banner>
		<!-- STATE 0: INVALID PLAN - Grace period active -->
		<div *ngIf="!xsmall && isOperator && warningMessage().planInvalidWarning && !isInvalidGracePeriodEnded()" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center; padding-top: 8px">
				<mat-icon class="mat-error-icon">error</mat-icon>
				<div>
					{{ ('SUBSCRIPTION.plan_invalid_grace_days' | translate).replace('{days}', getInvalidGraceDaysRemaining().toString()) | capitalize }}
					<a routerLink="/subscription">{{ 'SUBSCRIPTION.manage_subscription' | translate | capitalize }}</a>
				</div>
				<mat-icon class="mat-error-icon">error</mat-icon>
			</div>
		</div>

		<!-- STATE 0B: INVALID PLAN - Grace period has ended -->
		<div *ngIf="!xsmall && isOperator && warningMessage().planInvalidWarning && isInvalidGracePeriodEnded()" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center; padding-top: 8px">
				<mat-icon class="mat-error-icon">error</mat-icon>
				<div>
					{{ 'SUBSCRIPTION.plan_invalid_expired' | translate | capitalize }}
					<a routerLink="/subscription">{{ 'SUBSCRIPTION.manage_subscription' | translate | capitalize }}</a>
				</div>
				<mat-icon class="mat-error-icon">error</mat-icon>
			</div>
		</div>

		<!-- STATE 1: EXPIRING - Plan about to expire (before validUntil) -->
		<div *ngIf="!xsmall && isOperator && planState === 'EXPIRING'" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center; padding-top: 8px">
				<mat-icon class="mat-error-icon">warning</mat-icon>
				<div>
					{{ ('SUBSCRIPTION.plan_expiring_days' | translate).replace('{days}', getDaysRemaining().toString()) | capitalize }}
					<a routerLink="/subscription">{{ 'SUBSCRIPTION.manage_subscription' | translate | capitalize }}</a>
				</div>
				<mat-icon class="mat-error-icon">warning</mat-icon>
			</div>
		</div>

		<!-- STATE 2: EXPIRED_GRACE - Plan expired but grace period active -->
		<div *ngIf="!xsmall && isOperator && planState === 'EXPIRED_GRACE'" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center; padding-top: 8px">
				<mat-icon class="mat-error-icon">warning</mat-icon>
				<div>
					{{ ('SUBSCRIPTION.plan_expired_grace_days' | translate).replace('{days}', getDaysRemaining().toString()) | capitalize }}
					<a routerLink="/subscription">{{ 'SUBSCRIPTION.manage_subscription' | translate | capitalize }}</a>
				</div>
				<mat-icon class="mat-error-icon">warning</mat-icon>
			</div>
		</div>

		<!-- STATE 3: EXPIRED_FINAL - Grace period has ended -->
		<div *ngIf="!xsmall && isOperator && planState === 'EXPIRED_FINAL'" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center; padding-top: 8px">
				<mat-icon class="mat-error-icon">error</mat-icon>
				<div>
					{{ 'SUBSCRIPTION.plan_expired' | translate | capitalize }}
					<a routerLink="/subscription">{{ 'SUBSCRIPTION.manage_subscription' | translate | capitalize }}</a>
				</div>
				<mat-icon class="mat-error-icon">error</mat-icon>
			</div>
		</div>
		<div *ngIf="!xsmall && isOperator && warningMessage().smsSubscriptionWarning" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center; padding-top: 8px">
				<mat-icon class="mat-error-icon">warning</mat-icon>
				<div>
					{{ 'SUBSCRIPTION.sms_warning' | translate | capitalize }}
					<a routerLink="/subscription">{{ 'SUBSCRIPTION.order_sms' | translate | capitalize }}</a>
				</div>
				<mat-icon class="mat-error-icon">warning</mat-icon>
			</div>
		</div>
		<div *ngIf="!xsmall && isOperator && warningMessage().releaseNotesWarning" class="message">
			<div style="display: flex; justify-content: space-around; align-items: center">
				<div style="display: flex; justify-content: center; align-items: center; gap: 10px">
					<p>{{ ('VALIDATIONS.new_features_available' | translate | capitalize).replace('{0}', releaseNotesCount) }}</p>
					<button mat-icon-button (click)="showReleaseNotes()"><mat-icon>open_in_browser</mat-icon></button>
				</div>
			</div>
		</div>
		<mat-drawer-container [ngStyle]="{ height: 'calc(100vh - ' + warningMessage().margin + ')' }">
			<mat-drawer
				*ngIf="isOperator"
				#drawer
				[mode]="drawerMode"
				position="end"
				[ngStyle]="{
					'min-width': '380px',
					'padding.px': 10,
					border: '1px solid black'
				}"
			>
				<button *ngIf="drawerMode === 'over'" mat-icon-button (click)="toggleDrawerMode()" style="margin-bottom: 10px">
					<mat-icon>
						<span *ngIf="drawerMode === 'over'" class="material-symbols-outlined"> keep </span>
					</mat-icon>
				</button>
				<button
					*ngIf="drawerMode === 'side'"
					mat-icon-button
					(click)="toggleDrawerMode(); toggleDrawerStatus()"
					style="margin-bottom: 10px"
				>
					<mat-icon>
						<span class="material-symbols-outlined"> keep_off </span>
					</mat-icon>
				</button>
				<app-dashboard-sms *ngIf="isOperator"></app-dashboard-sms>
			</mat-drawer>
			<mat-drawer-content>
				<!-- 235: the floating "MSG" tab is gone — the messages button lives in the top toolbar (desktop + mobile) -->
				<router-outlet></router-outlet>
			</mat-drawer-content>
		</mat-drawer-container>
	</mat-sidenav-content>
</mat-sidenav-container>
